import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/UserDonations/config';
import cn from 'classnames';
import s from './UserDonations.scss';
const UserDonationsViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "userdonations",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
UserDonationsViewer.displayName = 'UserDonationsViewer';
export default UserDonationsViewer;

//# sourceMappingURL=UserDonations.js.map